<script>
export default {
  data() {
    return {
      primary_color: "#1d2088",
      secondary_color: "#1eb9ee",
    };
  },
  methods: {
    $urlCompatible(name, roll = false) {
      if (roll) {
        return name.toLowerCase().replace(/\s/g, "-");
      }
      return name.toLowerCase().replace(/\s/g, "-");
    },
    $url(name, roll = false) {
      if (roll) {
        return name.toLowerCase().replace(/\s/g, "-");
      }
      return name.toLowerCase().replace(/\s/g, "-");
    },
    $img(name) {
      return `/img/${name}`;
    },
    $upload(name) {
      return this.$store.state.apiUploadUrl + `${name}`;
    },
    $startLoader() {
      document.body.style.overflow = "hidden";
      this.$store.state.startLoader = true;
    },
    $stopLoader() {
      document.body.style.overflow = "auto";
      this.$store.state.startLoader = false;
    },
    $urlContains(url) {
      return this.$route.path.includes(url);
    },
    $AdminLogin(user, token) {
      localStorage.setItem("cumbinn_admin", JSON.stringify(user));
      localStorage.setItem("cumbinn_admin_token", token);
      this.$router.push({ name: "AdminDashboard" });
    },
    $UserLogin(user, token) {
      localStorage.setItem("cumbinn_user", JSON.stringify(user));
      localStorage.setItem("cumbinn_user_token", token);
      this.$router.push({ name: "Home" });
    },
    $getUser() {
      return JSON.parse(localStorage.getItem("cumbinn_admin"));
    },
    $getSiteUser() {
      return JSON.parse(localStorage.getItem("cumbinn_user"));
    },
    $getAdminToken() {
      return localStorage.getItem("cumbinn_admin_token");
    },
    $getUserToken() {
      return localStorage.getItem("cumbinn_user_token");
    },
    $userLogout() {
      localStorage.removeItem("cumbinn_admin");
      localStorage.removeItem("cumbinn_admin_token");
      this.$router.push({ name: "AdminLogin" });
    },
    $siteuserLogout() {
      localStorage.removeItem("cumbinn_user");
      localStorage.removeItem("cumbinn_user_token");
      window.location.reload();
    },
    $imageurlalt() {
      event.target.src = "https://via.placeholder.com/300";
    },
    $price(price) {
      if (isNaN(price)) {
        return price;
      } else {
        return "$" + price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }
    },
    $date(date, type = "date") {
      if (!date) {
        return;
      }
      let newDate = new Date(date);
      let year = newDate.getFullYear();
      let dayName = newDate.toLocaleString("default", { weekday: "long" });
      let dayNumber = newDate.toLocaleString("default", { day: "numeric" });
      // add 0 before day if less than 10
      if (dayNumber < 10) {
        dayNumber = "0" + dayNumber;
      }
      let monthName = newDate.toLocaleString("default", { month: "long" });
      let monthNameShort = newDate.toLocaleString("default", {
        month: "short",
      });
      let monthNumber = newDate.toLocaleString("default", { month: "numeric" });
      // add 0 before month if less than 10
      if (monthNumber < 10) {
        monthNumber = "0" + monthNumber;
      }
      let dateDots = `${dayNumber}.${monthNumber}.${year}`;
      if (type == "date") {
        return `${dayName}, ${dayNumber} ${monthName}, ${year}`;
      }
      if (type == "dots") {
        return dateDots;
      }
      if (type == "day") {
        return dayNumber;
      }
      if (type == "month") {
        return monthNameShort;
      }
      if (type == "year") {
        return year;
      }
    },
    $ago(date) {
      if (!date) {
        return;
      }
      // get time ago since  date
      let newDate = new Date(date);
      let today = new Date();
      let diff = today - newDate;
      let seconds = Math.floor(diff / 1000);
      let minutes = Math.floor(seconds / 60);
      let hours = Math.floor(minutes / 60);
      let days = Math.floor(hours / 24);
      let weeks = Math.floor(days / 7);
      let months = Math.floor(days / 30);
      let years = Math.floor(days / 365);
      if (seconds < 60) {
        return seconds + " seconds ago";
      } else if (minutes < 60) {
        return minutes + " minutes ago";
      } else if (hours < 24) {
        return hours + " hours ago";
      } else if (days < 7) {
        return days + " days ago";
      } else if (weeks < 4) {
        return weeks + " weeks ago";
      } else if (months < 12) {
        return months + " months ago";
      } else {
        return years + " years ago";
      }
    },
    $toggleSANav() {
      this.$store.state.showSANav = !this.$store.state.showSANav;
      localStorage.setItem("showSANav", this.$store.state.showSANav);
    },
    $comma(amount) {
      if (!amount) {
        return;
      }
      return amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    $changePage(page) {
      if (this.currentPage === page) return;
      this.currentPage = page;
      this.getItems();
    },
    $previousPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
        this.getItems();
      }
    },
    $nextPage() {
      if (this.currentPage < this.pagesNumber) {
        this.currentPage++;
        this.getItems();
      }
    },
    $today() {
      return new Date().toISOString().split("T")[0];
    },
    $cardnum(card) {
      if (!card) {
        return card;
      }
      return card.toString().replace(/\B(?=(\d{4})+(?!\d))/g, " ");
    },
    $checkline(line, phone) {
      if (!phone || phone == "" || phone == null) return false;
      if (line == "mtn") {
        if (
          phone.startsWith("078") ||
          phone.startsWith("079") ||
          phone.startsWith("25078") ||
          phone.startsWith("25079") ||
          phone.startsWith("+25078") ||
          phone.startsWith("+25079")
        ) {
          return true;
        } else {
          return false;
        }
      }
      if (line == "airtel") {
        if (
          phone.startsWith("073") ||
          phone.startsWith("072") ||
          phone.startsWith("25073") ||
          phone.startsWith("25072") ||
          phone.startsWith("+25073") ||
          phone.startsWith("+25072")
        ) {
          return true;
        } else {
          return false;
        }
      }
    },
    $site() {
      return this.$store.state.siteSettings;
    },
    $int(string) {
      return parseInt(string);
    },
    $ampm(time) {
      if (time) {
        let hours = time.split(":")[0];
        let minutes = time.split(":")[1];
        let ampm = hours >= 12 ? "PM" : "AM";
        hours = hours % 12;
        hours = hours ? hours : 12; // the hour '0' should be '12'
        minutes = minutes < 10 ? "0" + minutes : minutes;
        let strTime = hours + ":" + minutes + " " + ampm;
        return strTime;
      }
    },
  },
};
</script>